import configSelectors from 'selectors/configuration';
import appEvents from 'events/app';
import { getProactiveTriggered } from 'app/modules';
import showWidget from 'actions/ui/showWidget';
import isMobileWidth from 'lib/isMobileWidth';
import uiEvents from 'events/ui';

export default function executeRule(dispatch, getState) {
  const state = getState();
  const rule = configSelectors.getRule(state.configuration);
  const proactiveHasTriggered = getProactiveTriggered(state);

  dispatch(uiEvents.unsuppress());
  dispatch(uiEvents.updateVisibility(true));

  if (rule.proactive && !isMobileWidth() && !proactiveHasTriggered) {
    dispatch(uiEvents.unminimizeWidget());
    dispatch(showWidget());
    dispatch(appEvents.proactiveTriggered());
  }
}
